// Variable definitions

const state = {
    // Base
    apiServer : "http://10.10.15.100:3402",

    referentialData : [],
    selectedReferential : 0,
    criteriaTree: [],
    questionTree: [],
    canEditList: [
        {"referentialTitle": true}, 
        {"referentialDescription": true}, 
        { 'referentialCreatorOpen': false},
        { 'criteriaEditorOpen': false},
        { 'questionEditorOpen': false},
        { 'confirmationDialogOpen': false},
        { 'projectModalOpen': false},
    ],
    maxLength: [
        //login
        {'username': 50},
        {'password': 100},
        {'name': 50},
        {'email': 50},
        {'address': 255},
        {'phone': 20},
        // Referentiel
        {"id": 6},
        {"reference_id": 20},
        {"title": 200},/* SAME TYPE FOR EACH, MODIFY RECREATE.DB*/
        {"site": 100},
        {"description": 200},
        {"version": 50},
        //Criteria
        {"order_number": 11}, /* SAME TYPE FOR EACH, MODIFY RECREATE.DB */
        //Question
        //Projects
        //Answer

    ],
    activeCriteria: [],
    activeQuestion: [],
    callerObject: [],
    confirmationObject: [],
    loading: false,
    referentialDatabase: [],
    generalDataConfig: [],
    questionTags: [],
    evaluationTags: [],
    userList: [],
    userListRightsReferential: [],
    numberProjects: [],
    referentialErrors: {},
    userListRightsProject: [],
    unlockStatus: false,
    projectStatusByReferential: {}, // { [referentiel_id]: statusData
    pdf:[]
}

export default state;
